import api from '..'

const requests = {
    fetchAuthors: async ({ search, sortKey, sortType, pageSize, page }) => {
        var response = await api.get(`/wellful/Author/`, {
            params: {
                search,
                sortKey,
                sortType,
                pageSize,
                page
            }
        })

        return response.data
    },
    fetchAuthor: async (id) => {
        var response = await api.get(`/wellful/Author/${id}`)
        return response.data
    },
    createAuthor: async (payload) => {
        var response = await api.post(`/wellful/Author`, payload)
        return response.data
    },
    updateAuthor: async (payload) => {
        var response = await api.put(`/wellful/Author/${payload.id}`, payload)
        return response.data
    },
    updateProfileImage: async (id, payload) => {
        var formData = new FormData()

        formData.append('file', payload.file)

        return api.put(`/wellful/Author/${id}/ProfileImage`, formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        })
    },
    setReady: async (payload) => {
        var response = await api.put(`/wellful/Author/${payload.id}/Ready`, payload)
        return response.data
    }
}

export default requests
